/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

const mainContainer = (isSelected) => css`
    display: flex;
    align-items: center;
    padding: 4px 6px;
    margin: 2px 0;
    background-color: ${isSelected ? '#002755' : 'transparent'};
    color: ${isSelected ? 'white' : '#495057'};
    border-radius: 2px;
    font-size: 12px;
    font-weight: ${isSelected ? '500' : '400'};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${isSelected ? '#003366' : '#e9ecef'};
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const SelectMemuItem = ({ children, isSelected, onClick, display }) => {
    return (
        <div css={() => mainContainer(isSelected, display)} onClick={onClick}>
            {children}
        </div>
    );
};

export default SelectMemuItem;
